import { useSelector } from 'react-redux'
import useViewport from '../../common/hooks/useViewport'
import { Element } from '../../common/html/element'
import { Notification } from '../../common/notification'
import { ScrollComponent } from '../../common/scrollComponent'
import { Footer } from '../../layout/footer'
import { responsive } from '../../utils/layout'
import { Header } from './Header'
import { CompanyAlert } from './companyAlert'
import { selectOtherSetting } from './createEditProfile/store/slice'
import { EmailSetting } from './emailSetting'
import './i18n'
import classes from './index.module.scss'
import { IndustryAndMacro } from './industryAndMacro'

export const SETTING_SCROLL_ID = 'SETTING_SCROLL_ID'

export const Content = () => {
  const { width } = useViewport()
  const settingData = useSelector(selectOtherSetting())

  const isNoData = !Object.keys(settingData).length

  return (
    <Element
      id={SETTING_SCROLL_ID}
      className="wh100"
      style={{ backgroundColor: '#E5E5E5' }}
    >
      <ScrollComponent>
        <Element
          className={classes.container}
          style={{
            backgroundColor: '#FFFFFF',
            maxWidth:
              width > responsive.PIVOT_WIDTH ? responsive.PIVOT_WIDTH : '100%',
          }}
        >
          <Header />

          <div className={classes.panels}>
            {isNoData ? (
              <div className="mt5 pt5">
                <Notification />
              </div>
            ) : (
              <>
                <EmailSetting />
                <CompanyAlert />
                <IndustryAndMacro />
              </>
            )}
          </div>
        </Element>
        <Footer />
      </ScrollComponent>
    </Element>
  )
}
